export const setMenuActiveAction = () => (dispatch, getState) => {
        
    dispatch({
        type: "SET_MENU_ACTIVE",
        payload: !getState().MenuReducer.menuActive
    });
}


